// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3mcQ8","title":"Images45_title__BUEkJ","images":"Images45_images__2s8Bz"};